<template>
  <BaseModalBackdrop v-if="value" v-on:keydown.esc="onCloseClick" class="otp" :class="isIos ? 'pt-ios-inset-top' : 'pt-android-inset-top'">
    <form class="otp__form">
      <input type="hidden" value="phone">
      <input type="hidden" name="InputType" id="inputtype" value="manual"/>

      <span v-on:click.prevent="onCloseClick" class="otp__close" :class="isIos ? 'top-ios-inset-top' : 'top-android-inset-top'"></span>
      <div class="otp__title" v-html="translate('otp:title')"></div>
      <div v-html="translate('otp:text', phoneFormatted)" class="otp__text"></div>

      <div class="otp__sms-code-wrapper">
        <input v-mask="mask" v-model="form.smsCode" ref="smsCode" name="smsCode" type="tel" class="otp__sms-code" maxLength="4" autoComplete="off" autofocus />

        <div class="otp__mask-wrapper">
          <span v-bind:class="{ active: smsCodeLength >= 1 }" class="otp__mask-item" />
          <span v-bind:class="{ active: smsCodeLength >= 2 }" class="otp__mask-item" />
          <span v-bind:class="{ active: smsCodeLength >= 3 }" class="otp__mask-item" />
          <span v-bind:class="{ active: smsCodeLength >= 4 }" class="otp__mask-item" />
        </div>
      </div>

      <span v-if="timeLeft > 0" v-html="translate('otp:timer',timeLeft)" class="otp__timer"></span>

      <button v-if="timeLeft <= 0" v-on:click.prevent="onResendSmsClick" class="otp__btn" type="button">{{ translate('otp:btn') }}</button>
    </form>

    <alert v-if="error.isActiveAlert" v-model="error.isActiveAlert" v-bind:title="error.title" v-bind:text="error.text"></alert>
  </BaseModalBackdrop>
</template>

<script>
import './otp.scss'

import BaseModalBackdrop from '@/components/ui/BaseModalBackdrop/BaseModalBackdrop'
import Alert from '@/components/ui/Alert/Alert'

import { KASPI } from '@/config'
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { VueMaskDirective } from 'v-mask'
import Inputmask from 'inputmask'
import { createNumberMask } from 'text-mask-addons'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import IsAvailableStartReadingSms from '@/rules/IsAvailableStartReadingSms'
import IsAvailableStopReadingSms from '@/rules/IsAvailableStopReadingSms'
import { getDeviceType } from '@/helpers/getDeviceType'

const numberMask = createNumberMask({
  prefix: '',
  suffix: '',
  thousandsSeparatorSymbol: '',
  integerLimit: 4,
  allowLeadingZeroes: true
})

export default {
  name: 'Otp',
  components: {
    BaseModalBackdrop,
    Alert
  },
  directives: {
    mask: VueMaskDirective
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    isIos() {
      return getDeviceType() === 'ios'
    },
    phoneFormatted () {
      return Inputmask.format(this.phone, { mask: '+7 (999) 999-99-99' })
    }
  },
  data () {
    return {
      phone: '',
      prevMeta: {},
      isStartedReadingSms: false,
      mask: numberMask,
      timeout: null,
      totalSeconds: 60,
      timeLeft: 60,
      smsCodeLength: 0,
      form: {
        smsCode: ''
      },
      error: {
        isActiveAlert: false,
        title: '',
        text: ''
      }
    }
  },
  watch: {
    'form.smsCode': function (val) {
      this.smsCodeLength = val.length

      if (this.smsCodeLength === 4) {
        this.$refs.smsCode.blur()

        this.submit()
      }
    }
  },
  async created () {
    window.onSmsCodeReceived = (code) => {
      if (typeof code !== 'string') {
        code = code.toString()
      }

      if (code.length !== 4) {
        return
      }

      this.stopReadingSms()

      this.form.smsCode = code
    }

    await this.dataStep()

    this.startTimer()
    this.startReadingSms()
  },
  mounted () {
    sendAnalyticEvent('online_child_gold_sms_confirmation', {
      started_from: [this.$store.getters['app/urlParams'].startedFrom],
      stage: ['start'],
      page_path: ['/bank/bpm/products/goldkids/goldkid'],
      external_message_id: [this.$store.getters['goldkidProcess/pId']]
    })
    // KAFKA LOGGER
    this.$store.dispatch('goldkidProcess/logEventToKafka', {
      ver: 1,
      usrId: this.$store.getters['goldkidProcess/userData']?.userId,
      evt: 'gold_kid_events',
      act: 'online_child_gold_sms_confirmation'
    })

    this.$refs.smsCode.focus()

    document.getElementsByTagName('body')[0]
      .style.overflow = 'hidden'
  },
  beforeDestroy () {
    clearTimeout(this.timeout)

    document.getElementsByTagName('body')[0]
      .style.overflow = 'auto'

    this.stopReadingSms()
    window.onSmsCodeReceived = null

      sendAnalyticEvent('online_child_gold_sms_confirmation', {
        started_from: [this.$store.getters['app/urlParams'].startedFrom],
        stage: ['finish'],
        page_path: ['/bank/bpm/products/goldkids/goldkid'],
        external_message_id: [this.$store.getters['goldkidProcess/pId']]
      })
  },
  methods: {
    startReadingSms () {
      if ((new IsAvailableStartReadingSms()).isSatisfiedBy(KASPI.mobapp) && !this.isStartedReadingSms) {
        KASPI.mobapp.startReadingSms(60, 'window.onSmsCodeReceived')

        this.isStartedReadingSms = true
      }
    },
    stopReadingSms () {
      if ((new IsAvailableStopReadingSms()).isSatisfiedBy(KASPI.mobapp) && this.isStartedReadingSms) {
        KASPI.mobapp.stopReadingSms()

        this.isStartedReadingSms = false
      }
    },
    async dataStep () {
      await this.$store.dispatch('goldkidProcess/dataStep')
      this.phone = this.$store.getters['goldkidProcess/kidData'].phone
      eventBus.$emit('kaspiLoading', false)
    },
    startTimer () {
      if (this.timeLeft <= 0) {
        return
      }

      this.timeout = setTimeout(() => {
        this.timeLeft -= 1

        this.startTimer()
      }, 1000)
    },
    onCloseClick () {
      this.close()

      this.$store.dispatch('goldkidProcess/component', 'start')
    },
    close () {
      this.$emit('input', !this.value)
    },
    async submit () {
      if (this.form.smsCode.length !== 4) {
        return
      }

      eventBus.$emit('kaspiLoading', true)

      const data = this.getFormData()

      const response = await this.$store.dispatch('goldkidProcess/processStep', data)

      if (response?.data?.result.toLowerCase() === 'error') {
        this.error.title = response?.data?.data?.title
        this.error.text = response?.data?.data?.message
        this.error.isActiveAlert = true

        this.form.smsCode = ''

        eventBus.$emit('kaspiLoading', false)

        return
      }
      this.$store.dispatch('goldkidProcess/component', response?.data?.data?.component)
      this.close()
    },
    getFormData () {
      return {
        meta: {
          ...this.$store.getters['goldkidProcess/meta']
        },
        data: {
          smsCode: this.form.smsCode
        }
      }
    },
    async onResendSmsClick () {
      this.timeLeft = this.totalSeconds

      eventBus.$emit('kaspiLoading', true)

      await this.dataStep()

      this.startTimer()
    }
  }
}
</script>
